var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 13315"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z",
  "data-name": "Rectangle 2366"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  "data-name": "Group 13294"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.775 13.114h-3.128a4.21 4.21 0 0 0-4.209 4.208v8.891a4.21 4.21 0 0 0 4.209 4.209h3.159l2.238 2.735a1.237 1.237 0 0 0 1.915 0l2.238-2.735h3.159a4.21 4.21 0 0 0 4.208-4.209v-8.891a4.21 4.21 0 0 0-4.208-4.208h-2.34",
  "data-name": "Path 16476"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.193 6.39v15.411",
  "data-name": "Line 1029"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "m14.269 17.419 6.068 6.068 5.779-5.779",
  "data-name": "Path 16477"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.269 24.486h11.847",
  "data-name": "Line 1030"
})))));
export { SvgMessages as ReactComponent };
export default __webpack_public_path__ + "static/media/messages.7744bbba0ea438e1c9b37ab36d430316.svg";